import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    // g-car-59
    // apiKey: "AIzaSyD06g2B7LqMTUmK7CRIQDYIzk0Yivw0x48",
    // authDomain: "genius-car-services-60-38f52.firebaseapp.com",
    // projectId: "genius-car-services-60-38f52",
    // storageBucket: "genius-car-services-60-38f52.appspot.com",
    // messagingSenderId: "328537723678",
    // appId: "1:328537723678:web:7218068e83098d5b3f2f0f"

    // conceptual-react-auth 
    apiKey: "AIzaSyAN2CqYiYpNEyISIW2h0w9IDoLmcAmFES8",
    authDomain: "conceptual-react-auth.firebaseapp.com",
    projectId: "conceptual-react-auth",
    storageBucket: "conceptual-react-auth.appspot.com",
    messagingSenderId: "405325374522",
    appId: "1:405325374522:web:3e2cfaafbb29cd5249c103"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export default app;
